import type { OrganizationLimitDto } from './dto';
import type { RequestLimit } from './types';

export function toRequestLimit(dto: OrganizationLimitDto): RequestLimit {
    const used = dto?.count_scan_in_month ?? 0;
    const max = dto?.scan_limit_max ?? 0;

    const remaining = Math.max(max - used, 0);

    return {
        used,
        max,
        percent: max > 0 ? Math.min(Math.round((used / max) * 100), 100) : 0,
        remaining,
        isWarning: max > 0 && used >= max / 2,
        isReached: max > 0 && used >= max,
        organizationId: dto.id,
        organizationName: dto.name?.trim() ?? '',
        organizationInn: dto.inn,
    };
}